import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import App from './App';
import './index.css';
import { initErrorCapture } from '../../shared/errorReporting';
import { initLang, setCurrentLang } from './i18n';
import { LanguageProvider } from './hooks/useLanguage';

// Initialize error capture
initErrorCapture({
  app: 'crm',
  apiBase: import.meta.env.VITE_API_BASE || '',
});

// Initialize language and RTL/LTR direction
const initialLang = initLang();
setCurrentLang(initialLang);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Prevent unnecessary refetches on tab/modal switch
      staleTime: 1000 * 60, // 60 seconds
      gcTime: 1000 * 60 * 10, // 10 minutes cache
      retry: 1,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <LanguageProvider>
          <App />
          <Toaster position="top-center" />
        </LanguageProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
